import { tagFinderRegex } from '../constants';

export const countTags = (text: string): number => {
    try {
        const match = [...text.matchAll(new RegExp(tagFinderRegex, 'g'))];
        return match.length;
    } catch (err) {
        throw new Error(`Could not count tags: ${err}`);
    }
};
